import numbro from 'numbro';

/**
 * Shared constants and helpers for the user configurable "decimal places" feature.
 *
 * Numeric/float columns can opt in via `configurableDecimalPlaces: true` and provide a default
 * `decimalPlaces` value. The user can then change the number of displayed decimals in the table
 * settings modal (@/shared/components/ModalPageSettings.vue). The chosen value is forwarded to the
 * renderers (e.g. NumericRenderer, AmountUnitRenderer) via the Handsontable cell properties.
 */
export const MIN_DECIMAL_PLACES = 0;
export const MAX_DECIMAL_PLACES = 10;

export function clampDecimalPlaces(decimalPlaces: number): number {
  if (Number.isNaN(decimalPlaces)) return MIN_DECIMAL_PLACES;
  return Math.min(MAX_DECIMAL_PLACES, Math.max(MIN_DECIMAL_PLACES, Math.round(decimalPlaces)));
}

/**
 * Formats a numeric value with a fixed number of decimal places (thousand separated).
 */
export function formatWithDecimalPlaces(value: number, decimalPlaces: number): string {
  return numbro(value).format({
    thousandSeparated: true,
    mantissa: clampDecimalPlaces(decimalPlaces),
  });
}
